import { Helmet } from "react-helmet-async";

const SITE = "https://www.equilybra.com.br";
const DEFAULT_OG = `${SITE}/images/og-equilybra.jpg`;

interface SEOProps {
  title: string;
  description: string;
  path: string;
  image?: string;
  breadcrumbs?: { name: string; path: string }[];
  /** JSON-LD extra a injetar (ex: Service, Article). Objeto ou array. */
  jsonLd?: object | object[];
}

const SEO = ({ title, description, path, image = DEFAULT_OG, breadcrumbs, jsonLd }: SEOProps) => {
  const canonical = `${SITE}${path}`;
  const extraSchemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <meta name="geo.region" content="BR-SP" />
      <meta name="geo.placename" content="Ipiranga, São Paulo" />
      <meta name="geo.position" content="-23.5878;-46.6075" />
      <meta name="ICBM" content="-23.5878, -46.6075" />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:site_name" content="Equilybra Psicologia" />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@equilybrainsta" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {breadcrumbs && (
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: breadcrumbs.map((b, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: b.name,
            item: `${SITE}${b.path}`,
          })),
        })}</script>
      )}

      {extraSchemas.map((s, i) => (
        <script key={`jsonld-${i}`} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
};

export default SEO;
